<template>
  <div class="modal-wrapper">
    <div class="backdrop" v-if="showAddTags"></div>
    <addTagsToAnswers
      @addedTagsToAnswers="handleSaveAnswerTags"
      @closeAddTagsToQuestions="showAddTags = false"
      v-if="showAddTags"
      :question="addTagsToAnswersSelectedQuestion"
      :tags="tags"
    />
    <div class="navbar">
      <span>{{ pageTitle }}</span>
      <span class="material-icons" @click="close">clear</span>
    </div>
    <div class="title-of-questions-page">
      <span>Step:</span>
      <input type="text" v-model="title" />
    </div>
    <div class="questions" v-for="(question, i) in data" :key="i">
      <div class="top-row">
        <button class="button-round" @click="deleteQuestion(i)">
          <span class="material-icons">clear</span>
        </button>
        <select class="type" @change="handleTypeChange($event, i)">
          <option
            :selected="question.type === type"
            :value="type"
            v-for="(type, i) in questionTypes"
            :key="i"
          >
            {{ type }}
          </option>
        </select>
        <div class="add-new-answer" v-if="canAddNewAnswer(question.type)">
          <input
            type="text"
            v-model="question.temp"
            :placeholder="$t('adminPolls.addNewAnswer')"
            @keydown.enter="addNewAnswer(i)"
          />
          <button
            class="button-round button-round-small"
            @click="addNewAnswer(i)"
          >
            <span class="material-icons">add</span>
          </button>
          <button
            v-if="question.type !== 'text'"
            @click="openAddTagsToAnswers(question)"
            class="add-tags"
          >
            Add Tags To Answers
          </button>
        </div>
        <div class="select" v-if="question.type === 'select'">
          <select ref="select-element">
            <option
              v-for="(option, i) in question.answers.map((el) => {
                return el.text;
              })"
              :key="i"
            >
              {{ option }}
            </option>
          </select>
          <button @click="removeAnswer(question)">Remove</button>
        </div>
        <div
          class="select"
          v-if="question.type === 'checkbox' || question.type === 'radio'"
        >
          <select ref="select-element">
            <option
              v-for="(option, i) in question.answers.map((el) => {
                return el.text;
              })"
              :key="i"
            >
              {{ option }}
            </option>
          </select>
          <button @click="removeAnswer(question)">Remove</button>
        </div>
        <div class="select" v-if="question.type === 'badge'">
          <select ref="select-element">
            <option
              v-for="(option, i) in question.answers.map((el) => {
                return el.text;
              })"
              :key="i"
            >
              {{ option }}
            </option>
          </select>
          <button @click="removeAnswer(question)">Remove</button>
        </div>
        <div class="search-question">
          <label>Search question?</label>
          <input type="checkbox" v-model="question.pqt_search" />
          <input
            type="text"
            v-model.trim="question.pqt_short"
            placeholder="Search question shortcut..."
          />
        </div>
        <input
          type="number"
          placeholder="Unique code"
          class="unique-code-input"
          v-model="question.uniqueCode"
        />
      </div>
      <quillEditor class="title" v-model="question.text" :options="{placeholder: $t('adminPolls.noQuestionText')}" ref="myQuillEditor" />
      <div class="bot-row" v-if="question.type === 'radio'">
        <div class="answer" v-for="(ans, i2) of question.answers" :key="i2">
          {{ ans.text }}
          <button @click="removeConditionalId(ans)">Remove all</button>
          {{ ans.conditional }}
          <input type="text" v-model="ans.tempCID" />
          <button @click="addConditionalId(ans)">Add</button>
        </div>
      </div>
    </div>
    <div class="points">
      <span>Points</span>
      <input type="text" v-model="points" />
    </div>
    <!-- <div class="date-points-required" id="start-date">
      <div>
        <label for="start-date">Start Date</label>
        <input class="start-date" type="datetime-local" v-model="pollStart" />
      </div>
      <div>
        <label for="end-date">End Date</label>
        <input class="end-date" type="datetime-local" v-model="pollEnd" />
      </div>
      <div>
        <label for="required">Required</label>
        <input id="required" type="checkbox" v-model="required" />
      </div>
    </div> -->
    <DropDown
      :id="0"
      :options="tags"
      displayKey="tag_name"
      :isOpened="isOpened"
      :get-value="handleTags"
      class="dropdown"
      @set-opened="handleSetOpened"
    />
    <button class="button-round buttonz" @click="addNewQuestion">
      Add new question
    </button>
    <div class="buttons-wrap">
      <button class="button-round" @click="save">Save</button>
      <button class="button-round" @click="close">Cancel</button>
    </div>
  </div>
</template>

<script>
import addTagsToAnswers from "@/components/admin/polls/addTagsToAnswers";
import api from "@/api";
import DropDown from "@/components/list-of-attendees/DropDown.vue";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor,
    DropDown,
    addTagsToAnswers,
  },
  props: {
    page: Object,
  },
  data() {
    return {
      id: null,
      tempCondUID: "",
      title: "",
      data: [],
      newAnswer: "",
      questionTypes: ["select", "text", "badge", "checkbox", "radio"],
      hasSearchShortcutError: false,
      pollStart: null,
      pollEnd: null,
      required: false,
      points: 0,
      tags: [],
      isOpened: false,
      showAddTags: false,
      tempId: 1,
    };
  },
  computed: {
    pageTitle() {
      return this.page && this.page.title && this.page.data
        ? "Edit Page"
        : "New Page";
    },
  },
  mounted() {
    this.init();
    console.log(this.data, 123);
  },
  methods: {
    openAddTagsToAnswers(question) {
      // if(!question.pqa_id) {
      //   this.handleError(new Error("Add and save questions first"))
      //   return
      // }
      this.showAddTags = true;
      this.addTagsToAnswersSelectedQuestion = question;
    },
    handleSetOpened() {
      this.isOpened = !this.isOpened;
    },
    removeAnswer(question) {
      let options = this.$refs["select-element"][0].options;
      question.answers.splice(options.selectedIndex, 1);
      this.data = [...this.data];
    },
    init() {
      let page;
      if (this.page && this.page.data) {
        page = JSON.stringify(this.page);
        page = JSON.parse(page);
        this.id = page.ppg_id;
        this.title = page.title;
        this.data = page.data;
        console.log(page);
      }
      this.getAllTags();
    },
    deleteQuestion(index) {
      this.data.splice(index, 1);
    },
    save() {
      for (let i = 0; i < this.data.length; i++) {
        if (
          this.data[i].pqt_search &&
          (!this.data[i].pqt_short || this.data[i].pqt_short.length > 15)
        ) {
          this.data[i].pqt_short = "";
          this.handleError(
            new Error(
              "Search question shortcut can't be empty or greater than 15 characters."
            )
          );
          return;
        }
      }
      let page = {
        ppg_id: this.id,
        title: this.title,
        data: this.data,
        pls_points: this.points,
      };
      console.log("save page:");
      console.log(page);
      this.$emit("save", page);
    },

    close() {
      this.$emit("close");
    },
    canAddNewAnswer(type) {
      if (
        type === "badge" ||
        type === "checkbox" ||
        type === "select" ||
        type === "radio"
      )
        return true;
      else return false;
    },
    addNewAnswer(index) {
      let answer = this.data[index].temp;
      let newAnswer = {
        text: answer,
        tempCID: "",
      };
      let ans = this.data[index].answers;
      this.data[index].answers = [...(ans ? ans : [])];
      this.data[index].answers.push(newAnswer);
      this.data[index].temp = "";
    },
    handleTypeChange(e, index) {
      let newType = e.target.value;
      this.$set(this.data[index], "type", newType);
      if (!this.data[index].answers) {
        this.$set(this.data[index], "answers", []);
      }
    },
    addConditionalId(answer) {
      let conditionalUID = answer.tempCID;
      if (!conditionalUID) return;
      if (!answer.conditional) answer.conditional = [];
      this.$set(answer, "conditional", [...answer.conditional, conditionalUID]);
      answer.tempCID = "a";
      answer.tempCID = "";
      console.log(answer);
    },
    removeConditionalId(answer) {
      this.$set(answer, "conditional", []);
      answer.tempCID = "a";
      answer.tempCID = "";
      console.log(answer);
    },
    getBlankQuestion() {
      let question = {
        type: "text",
        answers: [],
        temp: "",
      };
      return question;
    },
    addNewQuestion() {
      let newQuestion = this.getBlankQuestion();
      this.data.push(newQuestion);
      console.log(this.data);
    },
    async getAllTags() {
      try {
        const res = await api.getTags();
        this.tags = res.data.result;
        console.log(res.data.result);
      } catch (error) {
        this.handleError(error);
      }
    },
    handleTags(tags) {
      console.log(tags);
    },
    handleSaveAnswerTags(data) {
      this.showAddTags = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  overflow: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  width: 99%;
  height: 90%;
  background: white;
  .backdrop {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.5;
    z-index: 10;
  }
  .dropdown {
    margin: 0 auto;
    display: block;
  }
  .navbar {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    .material-icons {
      cursor: pointer;
      position: absolute;
      right: 10px;
    }
  }
  .title-of-questions-page {
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      width: auto;
      margin: 10px;
    }
    input {
      max-width: 80%;
    }
  }
  @mixin f-s-c {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .questions {
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .add-tags {
      align-self: center;
      height: 50px
    }
    .top-row {
      @include f-s-c;
    }
    .bot-row {
      padding-left: 50px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      .answer {
        @include f-s-c;
      }
    }
    .button-round {
      width: 30px;
      min-width: 30px;
      height: 30px;
      span {
        font-size: 15px;
      }
    }
    .type {
      margin: 0 10px;
      min-width: 120px;
    }
    .title {
      margin: 0 auto;
      width: 80%;
    }
    .select {
      min-width: 200px;
      display: flex;
      select {
        width: 70%;
      }
      button {
        margin-left: 5%;
        width: auto;
      }
    }
    .add-new-answer {
      margin: 0 10px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      input {
        width: 50%;
      }
      .button-round-small {
        margin-left: 10px;
        width: 40px;
        min-width: 0;
      }
    }
    .search-question {
      display: flex;
      align-items: center;
      margin-left: 10px;
      input[type="checkbox"] {
        min-width: 15px;
        min-height: 15px;
        margin-right: 30px;
      }
    }
    .unique-code-input {
      width: 150px;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .date-points-required {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 30px;
    & > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    input[type="text"] {
      width: 300px;
    }
  }
  .buttonz {
    margin: 100px auto 0 auto;
  }
  .buttons-wrap {
    margin: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .points {
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
  }
}
</style>